import { useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';
import { get } from 'lodash';

import { useCurrentAccountId } from '@zapier/design-system-revenue/src/hooks';

import { accountSwitchQuery as AccountSwitchQueryResult } from './types/accountSwitchQuery';

export const accountSwitchQuery = gql`
  query accountSwitchQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      switches
    }
  }
`;

type UseAccountSwitchOutput = {
  error: string | undefined;
  isLoading: boolean;
  isSwitchOn: boolean;
};

export const useAccountSwitch = (
  switchName: string
): UseAccountSwitchOutput => {
  const { accountId } = useCurrentAccountId();

  const { data, error, loading } = useQuery<AccountSwitchQueryResult>(
    accountSwitchQuery,
    {
      // Refetch from network in case user changes from logged
      // out to logged in, which can affect their switches.
      fetchPolicy: 'cache-and-network',
      skip: !accountId,
      variables: { accountId },
    }
  );

  const currentAccount = data?.account;

  return {
    error: error ? 'There was an issue loading data.' : undefined,
    isLoading: loading,
    isSwitchOn: get(currentAccount, ['switches', switchName], false),
  };
};
